import React from 'react';

import {AccessibleGridCell, Grid} from 'constants/SampleConstants';
import {FillDirection} from 'lookup-config/LookupConfigModalConstants';
import GridCellToolbarActionButtons from 'samples/grids/GridCellToolbarActionButtons';
import GridCellToolbarContents from 'samples/grids/GridCellToolbarContents';
import GridActionsDropdown from 'samples/toolbar/GridActionsDropdown';
import getTestProps from 'test/lib/cypress/getTestProps';
import {ButtonStyle} from 'ui-library/buttons/Button';

export interface GridCellToolbarProps {
  cells: Array<AccessibleGridCell>;
  grid: Grid;
  isWritable: boolean;
  selectedCells: Array<AccessibleGridCell>;
  onSubmitScanToFillModal: (fillDirection: FillDirection) => void;
}

export default function GridCellToolbar(props: GridCellToolbarProps): JSX.Element {
  const selectedContainers = props.selectedCells.map(({container}) => container);
  const selectedContainerIds = selectedContainers.map((container) => container.id);

  return (
    <div className="buttonToolbar" {...getTestProps({component: 'GridCellToolbar', element: 'root'})}>
      {props.isWritable && (
        <GridCellToolbarActionButtons grid={props.grid} selectedCells={props.selectedCells} />
      )}
      <GridCellToolbarContents
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        storables={props.cells.map(({container}) => container)}
        grid={props.grid}
        selectedIds={selectedContainerIds}
      />
      {props.isWritable && (
        <GridActionsDropdown
          cells={props.cells}
          grid={props.grid}
          onSubmitScanToFillModal={props.onSubmitScanToFillModal}
        />
      )}
    </div>
  );
}
